import { Fragment } from "react";

/**
 * URL regex — matches http/https URLs in plain text.
 * Avoids trailing punctuation (.,;:!?) and quotes.
 */
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\"'])/g;

interface LinkifyProps {
  text: string;
  className?: string;
}

/**
 * Renders plain text with auto-detected URLs as clickable links.
 * All links open in a new tab with noopener/noreferrer.
 */
export default function Linkify({ text, className }: LinkifyProps) {
  const parts = text.split(URL_REGEX);

  if (parts.length === 1) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={className}>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline hover:text-primary/80 break-all"
          >
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </span>
  );
}
